import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { setUserTemplateSearchText } from "../../../store/templateList";
import { selectUserTemplateSearchText } from "../../../store/templateList/selectors/selectUserTemplateSearchText";

export const UserTemplateSearchBar = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(selectUserTemplateSearchText);

  return (
    <IonSearchbar
      value={searchText}
      onIonChange={({ detail: { value = "" } }) => {
        dispatch(setUserTemplateSearchText(value));
      }}
      debounce={700}
      placeholder={"Buscar plantilla..."}
    />
  );
};
